const initialState = {
  site: {},
  siteSummary: {},
  sites: [],
  fetching: false,
  fetched: false,
  errors: null,
  saved: false,
  saving: false,
}

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case "SITES_FETCH_PENDING":
    case "CHILD_COMPANY_SITES_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        errors: null,
      }
    case "SITES_FETCH_REJECTED":
    case "CHILD_COMPANY_SITES_FETCH_REJECTED":
      return {
        ...state,
        fetching: false,
        errors: action.payload.response ? action.payload.response.data.errors : action.payload.message,
      }
    case "SITES_FETCH_FULFILLED":
    case "CHILD_COMPANY_SITES_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        sites: action.payload.data,
        errors: null,
      }
    case "SITE_FETCH_PENDING":
      return {
        ...state,
        fetching: true,
        fetched: false,
        site: null
      }
    case "SITE_FETCH_FULFILLED":
      return {
        ...state,
        fetching: false,
        fetched: true,
        site: action.payload.data
      }
    case  'USER_SIGN_OUT_PENDING':
      return {
        ...initialState
      }
    case 'USER_SIGN_OUT_FULFILLED':
      return {
        ...initialState
      }
    default:
      return state
  }
}




// WEBPACK FOOTER //
// ./src/reducers/sitesReducer.js